export default "__VITE_ASSET__Cllct7pa__"